import { render, staticRenderFns } from "./MultiMediaStatsChart.vue?vue&type=template&id=a1bd8804&scoped=true&"
import script from "./MultiMediaStatsChart.vue?vue&type=script&lang=js&"
export * from "./MultiMediaStatsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bd8804",
  null
  
)

export default component.exports